<template>
  <a-row id="user-row" :gutter="20">
    <a-col :span="10">
      <a-card style="border-right:1px solid #eee;" :judge-width="true" size="small">
        <div class="list">
          <div class="item">
            <div class="item-t">用户总数</div>
            <div class="item-b">{{userData.userSum}}</div>
          </div>
          <span class="line"></span>
          <div class="item">
            <div class="item-t">新增(日/周/月)</div>
            <div class="item-b">{{userData.dayNum}}/{{userData.weekNum}}/{{userData.monthNum}}</div>
          </div>
        </div>
      </a-card>
    </a-col>
    <a-col :span="14">
      <a-card size="small">
        <div class="list">
          <div class="item">
            <div class="item-t">企业数</div>
            <div class="item-b">{{deptData.deptNum}}</div>
          </div>
          <span class="line"></span>
          <div class="item">
            <div class="item-t">中介数</div>
            <div class="item-b">{{deptData.deptOrgNum}}</div>
          </div>
          <span class="line"></span>
          <div class="item">
            <div class="item-t">证书量</div>
            <div class="item-b">{{deptData.certNum}}</div>
          </div>
          <span class="line"></span>
          <div class="item">
            <div class="item-t">报告量</div>
            <div class="item-b">{{deptData.reportNum}}</div>
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import {adminUser,adminDept} from '@/api/user'
export default {
  data() {
    return {
      userData:{},
      deptData:{},
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      this.getAdminUser()
      this.getAdminDept()
    },
    //adminUser
    async getAdminUser(){
      try {
        let data = await adminUser()
        this.userData = data
      }catch(error){
        console.log(error)
      }
    },
    async getAdminDept(){
      try {
        let data = await adminDept()
        this.deptData = data
      }catch(error){
        console.log(error)
      }
    },

  },
};
</script>

<style lang="less" scoped>
#user-row {
  /deep/.ant-card {
    height: 200px;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,.1);
    
    .ant-card-body {
      height: 100%;
    }

    .list {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .item {
        width: ~'calc(33.3% - 3px)';
        text-align: center;

        .item-t {
          
          font-size: 16px;
          padding-bottom: 6px;
        }

        .item-b {
          font-size: 18px;
          font-weight: bold;
        }
      }
      span.line {
        width: 1px;
        height: 80px;
        background-color: #ccc;

      }
    }


  }
}
</style>
